export default "__VITE_ASSET__S1pYOHqx__"